<template>
    <div
        class="is-flex is-multiline is-variable is-1 is-justify-content-center is-align-items-center is-flex-direction-column">
        <b-notification style="width:100%" v-if="showWarningOutdatedBook" has-icon :closable="false"
            type="is-danger is-light" icon="info-circle" aria-close-label="Close notification" role="alert">
            <p style="padding-top: 11px">
                {{ this.msgNotificationUpdate }}
            </p>
        </b-notification>
        <p class="has-text-weight-bold mb-4">
            {{ this.msgTitle }}
        </p>
        <b-button type="is-secondary" :icon-right="'upload'" @click="openModalBookObligations()"
            :disabled="!isBookCompleteTransaction || disableUploadBtn">
            <span v-if="isBookCompleteTransaction">{{ this.msgBtn }}</span>
            <span v-else>{{ this.msgValidateBtn }}</span>
        </b-button>
        <p v-if="!isBookCompleteTransaction" class="has-text-weight-bold has-text-contrast mt-2">
            Espera a que termine la validación de tu archivo
            <br />
        </p>
        <div v-if="!hideErrors && (documentHasErrors || isDocumentInvalidBySocket)">
            <br />
            <error-notification :msg="errorMsg" :type="errorType" />
        </div>
        <p v-if="documentIsValidated ||
            (isBookCompleteTransaction && isDocumentValidBySocket)
            " class="has-text-weight-bold has-text-success mt-2">
            <span>{{
                momentFixed(this.msgUpdateUntil,
                    getWebSocket().responseMessage.payroll_filled_until)
                }}
            </span>
            <br />
        </p>
        <p v-if="this.showMsgRemember" class="has-text-grey mt-2">
            {{ this.msgRemember }}
        </p>
    </div>
</template>

<script>
import { checkStatusValidation } from "@/api/s3BookRemunerations";
import { checkStatusFilesValidation } from "@/api/uploadFiles";
import ErrorNotification from "@/components/obligations/ErrorNotification";
import moment from "moment";
import { mapActions, mapMutations, mapState } from "vuex";
export default {
    name: "FormObligationGeneric",
    components: {
        ErrorNotification,
    },
    props: [
        "msgTitle",
        "msgBtn",
        "msgValidateBtn",
        "showMsgRemember",
        "msgRemember",
        "msgUpdateUntil",
        "msgNotificationUpdate",
        "kind_file",
        "hideErrors",
        "disableUploadBtn",
        "nodate",
    ],
    data() {
        return {
            book: {},
            errorMsg: null,
            errorType: null,
        };
    },
    methods: {
        ...mapActions("bookRemunerations", [
            "startWebSocket",
            "checkStatusValidationDocument",
        ]),
        ...mapMutations("bookRemunerations", [
            "SET_WEBSOCKET",
            "SET_TRANSACTION",
        ]),
        openModalBookObligations() {
            this.$emit("openModal", {
                book: this.book,
            });
        },
        updateErrorMsg(msg) {
            this.errorMsg = msg;
            if (msg && "HEADERS_ERRORS" in msg) {
                this.errorType = "HEADERS";
            } else if (msg && "FILES" in msg) {
                this.errorType = "FILES";
            } else {
                this.errorType = "COLUMNS";
            }
        },
        momentFixed(message, date) {
            const val = moment(date).format("MMMM YYYY");
            if (val == "Fecha inválida") {
                return "";
            }
            if (this.nodate != null && this.nodate == true) {
                return ""
            }
            return message + ' ' + val;
        },
        getWebSocket: function () {
            let websocketData = null;
            if (this.kind_file == "remuneration") {
                websocketData = this.webSocketRemunerations;
            } else if (this.kind_file == 'other_obligations') {
                websocketData = this.webSocketOtherRemunerations;
            } else if (this.kind_file == "remuneraciones") {
                websocketData = this.webSocketRemuneraciones
            } else if (this.kind_file == "facturas_extranjeras") {
                websocketData = this.webSocketFacturasExtranjeras
            } else if (this.kind_file == "recibos") {
                websocketData = this.webSocketRecibos
            } else if (this.kind_file == "finiquitos") {
                websocketData = this.webSocketFiniquitos
            } else if (this.kind_file == "exportable_erp") {
                websocketData = this.webSocketExportableErp
            } else if (this.kind_file == "creditos") {
                websocketData = this.webSocketCreditos
            } else if (this.kind_file == "balance_8_columnas") {
                websocketData = this.webSocketBalance8Columnas
            } else if (this.kind_file == "libro_bancos") {
                websocketData = this.webSocketLibroBancos
            } else if (this.kind_file == "data_operacional_complementaria") {
                websocketData = this.webSocketDataOperacionalComplementaria
            }
            return websocketData;
        },
    },
    computed: {
        ...mapState("bookRemunerations", [
            "webSocketRemunerations",
            "webSocketOtherRemunerations",
            "webSocketForFiles",
            "webSocketRemuneraciones",
            "webSocketFacturasExtranjeras",
            "webSocketRecibos",
            "webSocketFiniquitos",
            "webSocketExportableErp",
            "webSocketCreditos",
            "webSocketBalance8Columnas",
            "webSocketLibroBancos",
            "webSocketDataOperacionalComplementaria",
        ]),
        ...mapState("userAuth", ["user"]),
        documentHasErrors: function () {
            const hasError = this.book.validation_status === "E";
            if (hasError) {
                this.updateErrorMsg(this.book.errors);
            }
            return hasError;
        },
        showWarningOutdatedBook: function () {
            let showWarning = false;
            let websocketData = this.getWebSocket();
            if (!websocketData) return
            const responseMessage = websocketData.responseMessage;
            const payrollLastDate = responseMessage?.payroll_filled_until;
            const updateDate = moment(payrollLastDate).add(2, "M");
            const currentDate = Date.now();
            if (payrollLastDate) {
                if (currentDate > updateDate) {
                    showWarning = true;
                }
            }
            return showWarning;
        },
        isBookCompleteTransaction: function () {
            let websocketData = this.getWebSocket();
            if (!websocketData) return false
            return !!websocketData.responseMessage?.complete_transaction;
        },
        isDocumentInvalidBySocket: function () {
            let hasError = false;
            let websocketData = this.getWebSocket();
            if (
                websocketData.responseMessage?.validation_status === "E" &&
                websocketData.responseMessage?.errors !== ""
            ) {
                hasError = true;
            }
            if (hasError) {
                this.updateErrorMsg(websocketData.responseMessage.errors);
            }
            return hasError;
        },
        documentIsValidated: function () {
            return this.book.validation_status === "V" || this.book.validation_status === "SUBIDO_EXITOSAMENTE";
        },
        isDocumentValidBySocket: function () {
            let websocketData = this.getWebSocket();
            if (!websocketData) return false
            return (
                websocketData.responseMessage?.validation_status === "V" ||
                websocketData.responseMessage?.validation_status === "SUBIDO_EXITOSAMENTE" ||
                false
            );
        },
    },
    mounted() {
        let checkValidation = null
        if (this.kind_file == 'remuneration' || this.kind_file == 'other_obligations') {
            checkValidation = checkStatusValidation
        } else {
            checkValidation = checkStatusFilesValidation
        }
        checkValidation(this.kind_file).then((response) => {
            const hasDocumentUploaded = "validation_status" in response.data;
            if (hasDocumentUploaded) {
                const validationStatus = response.data.validation_status;
                const responseMessage = response.data;
                this.book = response.data;
                if (validationStatus === "P") {
                    this.startWebSocket(this.kind_file);
                } else {
                    this.SET_WEBSOCKET({ responseMessage });
                }
            } else {
                this.SET_TRANSACTION({
                    complete_transaction: true,
                    kind_file: this.kind_file,
                });
            }
        });
    },
};
</script>
